import { useState } from 'react';
import { clubsService } from '@/features/clubs/services/clubsService';

export default function ClubDebug() {
  const [testResult, setTestResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testGetAllClubs = async () => {
    setLoading(true);
    try {
      const clubs = await clubsService.getAllClubs();
      setTestResult(`Success! Found ${clubs.length} clubs. First club: ${clubs[0]?.name || 'None'}`);
    } catch (error) {
      setTestResult(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  const testGetClubByHandle = async () => {
    setLoading(true);
    try {
      const club = await clubsService.getClubByHandle('hilondon');
      setTestResult(`Success! Found club: ${club.name} - ${club.description}`);
    } catch (error) {
      setTestResult(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-700 rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Club API Debug</h3>
      
      <div className="space-y-4">
        <button
          onClick={testGetAllClubs}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
        >
          {loading ? 'Testing...' : 'Test GetAllClubs'}
        </button>
        
        <button
          onClick={testGetClubByHandle}
          disabled={loading}
          className="px-4 py-2 bg-green-600 text-white rounded disabled:opacity-50 ml-2"
        >
          {loading ? 'Testing...' : 'Test GetClubByHandle'}
        </button>
        
        {testResult && (
          <div className="mt-4 p-3 bg-white text-black rounded border">
            <strong>Result:</strong> {testResult}
          </div>
        )}
      </div>
    </div>
  );
}
